<template>
  <div class="mb-4">

    <!--#region -- Content ---->
    <!--#region SFDC Synchronization Real Data-->

      <div class="caption-label-hide d-flex" style="margin-left: -17px;">
        <div class="caption-label">

          <b-badge style="margin-right: 10px;" v-if="sfdcProducts" variant="primary">{{sfdcProducts.length}}</b-badge>
          <b-badge style="margin-right: 10px;" v-else variant="primary">0</b-badge>
          Salesforce Product
          <b-button v-b-toggle.collapseProducts
                    variant="outline-primary"
                    class="text-primary text-left"
                    style="background-color: white; border: none; padding-left: 26px;">
            <b-icon :icon="isCollapsedProduct ? 'chevron-down' : 'chevron-up'"></b-icon>
          </b-button>
        </div>
      </div>
      <b-collapse id="collapseProducts"
                  @shown="onShown" @hidden="onHidden"
                  accordion="Salesforce Product" role="tabpanel">
        <div style="padding-top: 10px;" v-if="sfdcProducts">
          <b-table :fields="sfdcProductFields" :items="sfdcProducts"
                   small
                   thead-class="thead-light text-dark"
                   :busy="searching"
                   style="width: calc(100% - 10px)">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(ftie_id_list)="data">
              <div v-for="item_ftie in data.item.ftie_id_list">
                <a class="link" target="_blank" :href="`${ frontEndUrlToUse }ftie/ftie-page/${ item_ftie }`">
                  {{item_ftie}}
                </a>
                <br>
              </div>
            </template>

          </b-table>
        </div>
      </b-collapse>

      


    <!--#endregion-->
    <!-- #endregion Modal-->
  </div>
</template>

<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'sfdc-prd-line-view-only',
    props: {
      prop_sfdc_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },

    },
    data: function () {
      return {
        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        sfdcProducts: null,
        sfdcProductsOriginal: null,
        fixModel: true,
        fixCustomizationPn: "Customization",
        basicInfo: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        ftieId: encodeURIComponent(this.$route.params.ftie_id),
        createBy: null,
        realSkuNo: null,
        autopilotOptions: [{ text: 'No', value: 'No' }, { text: 'Yes', value: 'Yes' }],
        searching: false,
        maintianPnHint: '* Please maintain PN',
        noneSelectedHint: '',
        isCollapsedProduct: true,
        sfdcProductFields: [
          { key: 'model_name', label: 'Model', thClass: 'align-middle', sortable: true },
          { key: 'product_group', label: 'Product Group', thClass: 'align-middle', sortable: true },
          { key: 'standard_sku_id', label: 'Standard SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'ftie_id_list', label: 'FTIE', thClass: 'align-middle', sortable: true },

          //{ key: 'customization_sku_id', label: 'Customization SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'deployment_status', label: 'Deployment Status', thClass: 'align-middle', sortable: true },

          {
            key: 'std_mps_pn', label: 'Standard MPS PN',
            thClass: 'align-middle',
            //tdClass: 'min-w-90', 
            sortable: true
          },
          {
            key: 'customization_shipping_pn', label: 'Customization SHIP PN',
            thClass: 'align-middle',
            //tdClass: 'min-w-90', 
            sortable: true
          },
          { key: 'quantity', label: 'Qty', thClass: 'align-middle', sortable: true },
          { key: 'product_date', label: 'Product Demand Date', thClass: 'align-middle', tdClass: 'min-w-200', sortable: true },
          { key: 'configuration', label: 'Configuration', thClass: 'align-middle', tdClass: 'min-w-200', sortable: true },
          { key: 'last_edit_date', label: 'Last Edit Date', thClass: 'align-middle', sortable: true }
        ],


        selectedMpsIdToSync: [],
        reloadBusy: false,
        processedIndex: [],
        customizationPnWarning: null,
        customizationPnModalData: {
          itemObj: null,

          shippedPnToSyncNew: null,
          shippedPnToSync: null,

          mpsPnToSyncNew: null,
          mpsPnToSync: null,
          sfdcPrdLines:null,
          mpsIdList: null,
          mpsId: null,

          customSkuId: null,
          refSkuId: null,
          optyName: null,
          optyId: null,
          esNumber: null,
          saTickAutopilotFlag: null,
          confirmAutopilotReq: null, //        sa_selected_autopilot: null,
          mpsPnStd: null,
          shipPnStd: null
        },
      }
    },
    computed: {
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },

    },
    created() {
      let self = this;
      self.sfdcProducts = self.prop_sfdc_page_obj;
      self.sfdcProductsOriginal = self.prop_sfdc_page_obj;
      self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.actionEnable = self.checkActionEnable();
      // console.log("SFDC Copo actionEnable:");
      // console.log(self.actionEnable);
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      onShown() {
        this.isCollapsedProduct = false;
      },
      onHidden() {
        this.isCollapsedProduct = true;
      },
      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if (self.loginUser === 'power') {
          return true;
        }

        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        //login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles !== null && userRoles.includes('Admin')))
        return false;
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework-sfdc/SfdcPrdLineDisplayOnly.vue